import React from "react";
import DashboardHeader from "../../components/Admin/DashboardHeader";
import DashboardSideBar from "../../components/Admin/DashboardSideBar";
import DashboardHero from "../../components/Admin/DashboardHero";

import "./AdminDashPage.scss";

const AdminDashPage = () => {
  return (
    <div className="admin-dashboard">
      <DashboardHeader />
      <div className="admin-dashboard__wrapper">
        <div className="admin-dashboard__container">
          <div className="admin-dashboard__sidebar">
            <DashboardSideBar active={1} />
          </div>
          <div className="admin-dashboard__hero">
            <DashboardHero />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashPage;
